// actions for api requests
export const FETCH_SURVEY_TYPES = 'FETCH_SURVEY_TYPES';
export const FETCH_SURVEY_DEPLOYMENTS = 'FETCH_SURVEY_DEPLOYMENTS';
export const FETCH_SURVEY_DETAIL = 'FETCH_SURVEY_DETAIL';
export const FETCH_SURVEY_DETAIL_BY_UUID = 'FETCH_SURVEY_DETAIL_BY_UUID';
export const FETCH_SURVEY_DETAIL_BY_STEP = 'FETCH_SURVEY_DETAIL_BY_STEP';
export const FETCH_SURVEYS_LIST = 'FETCH_SURVEYS_LIST';
export const FETCH_SURVEYS_MAP_LIST = 'FETCH_SURVEYS_MAP_LIST';
export const SET_SURVEYS_MAP_LIST = 'SET_SURVEYS_MAP_LIST';
export const FETCH_QUESTION_LIST = 'FETCH_QUESTION_LIST';
export const FETCH_QUESTION_LIST_NOT_IN_SURVEY = 'FETCH_QUESTION_LIST_NOT_IN_SURVEY';
export const CREATE_SURVEY_REQUEST = 'CREATE_SURVEY_REQUEST';
export const CREATE_COPIED_SURVEY_REQUEST = 'CREATE_COPIED_SURVEY_REQUEST';
export const UPDATE_SURVEY_FORM_REQUEST = 'UPDATE_SURVEY_FORM_REQUEST';
export const UPDATE_SURVEY_REQUEST = 'UPDATE_SURVEY_REQUEST';
export const UPDATE_SURVEY_STATUS_REQUEST = 'UPDATE_SURVEY_STATUS_REQUEST';
export const QUESTION_CREATE_REQUEST = 'QUESTION_CREATE_REQUEST';
export const QUESTION_LOGIC_CREATE_REQUEST = 'QUESTION_LOGIC_CREATE_REQUEST';
export const QUESTION_LOGIC_UPDATE_REQUEST = 'QUESTION_LOGIC_UPDATE_REQUEST';
export const QUESTION_LOGIC_DELETE_REQUEST = 'QUESTION_LOGIC_DELETE_REQUEST';
export const DELETE_LOGIC_BY_QUESTION_REQUEST = 'DELETE_LOGIC_BY_QUESTION_REQUEST';
export const FETCH_SURVEY_GROUP_QUESTION_BY_TITLE = 'FETCH_SURVEY_GROUP_QUESTION_BY_TITLE';
export const CREATE_SURVEY_GROUP_QUESTION = 'CREATE_SURVEY_GROUP_QUESTION';
export const UPDATE_GROUP_QUESTIONS_REQUEST = 'UPDATE_GROUP_QUESTIONS_REQUEST';
export const ADD_QUESTIONS_FROM_LIBRARY_REQUEST = 'ADD_QUESTIONS_FROM_LIBRARY_REQUEST';
export const CHECK_VALID_LOGIC_REQUEST = 'CHECK_VALID_LOGIC_REQUEST';
export const REORDER_QUESTION_REQUEST = 'REORDER_QUESTION_REQUEST';
export const ACTION_STANDARD_SURVEY = 'ACTION_STANDARD_SURVEY';
export const SEARCH_QUESTIONS_FROM_LIBRARY_REQUEST = 'SEARCH_QUESTIONS_FROM_LIBRARY_REQUEST';
export const FETCH_SURVEY_EXTRACT_STATUS = 'FETCH_SURVEY_EXTRACT_STATUS';
export const FETCH_SURVEY_EXTRACT_FILE = 'FETCH_SURVEY_EXTRACT_FILE';
export const FETCH_SURVEY_EXTRACT_INSTANCES_FILE = 'FETCH_SURVEY_EXTRACT_INSTANCES_FILE';
export const FETCH_SURVEY_PUBLISH_DATETIME = 'FETCH_SURVEY_PUBLISH_DATETIME';
export const FETCH_QUESTION_LIBRARY = 'FETCH_QUESTION_LIBRARY';
export const CREATE_SURVEY_SCORE_LOGIC = 'CREATE_SURVEY_SCORE_LOGIC';
export const FETCH_SURVEY_TOTAL_SCORE = 'FETCH_SURVEY_TOTAL_SCORE';
export const FETCH_SURVEY_HPA_SCORE_CATEGORIES = 'FETCH_SURVEY_HPA_SCORE_CATEGORIES';

// actions for state
export const SET_SURVEY_TYPES = 'SET_SURVEY_TYPES';
export const SET_SURVEY_DEPLOYMENTS = 'SET_SURVEY_DEPLOYMENTS';
export const FETCH_SURVEYS = 'FETCH_SURVEYS';
export const SET_SURVEY_DETAIL = 'SET_SURVEY_DETAIL';
export const FETCH_QUESTION_TYPES = 'FETCH_QUESTION_TYPES';
export const FETCH_CHANGE_MODEL = 'FETCH_CHANGE_MODEL';
export const SET_SURVEYS_LIST = 'SET_SURVEYS_LIST';
export const GET_SURVEYS = 'GET_SURVEYS';
export const SET_SURVEYS = 'SET_SURVEYS';
export const SET_CURRENT_SURVEY = 'SET_CURRENT_SURVEY';
export const SET_ADD_CURRENT_SURVEY = 'SET_ADD_CURRENT_SURVEY';
export const ADD_QUESTION_TO_SURVEY = 'ADD_QUESTION_TO_SURVEY';
export const SET_ADD_QUESTION_TO_SURVEY = 'SET_ADD_QUESTION_TO_SURVEY';
export const DELETE_SURVEY = 'DELETE_SURVEY';
export const CANCEL_SURVEY = 'CANCEL_SURVEY';
export const SET_DELETE_SURVEY = 'SET_DELETE_SURVEY';
export const SET_QUESTION_TYPES = 'SET_QUESTION_TYPES';
export const SET_CHANGE_MODEL = 'SET_CHANGE_MODEL';
export const ADD_SELECTED_CHANGE_MODEL = 'ADD_SELECTED_CHANGE_MODEL';
export const SET_SELECTED_CHANGE_MODEL = 'SET_SELECTED_CHANGE_MODEL';
export const SET_QUESTION_LIST = 'SET_QUESTION_LIST';
export const SET_QUESTION_LIST_ACTION = 'SET_QUESTION_LIST_ACTION';
export const SET_ALL_QUESTIONS_LIST = 'SET_ALL_QUESTIONS_LIST';
export const QUESTION_ADD_ANSWER = 'QUESTION_ADD_ANSWER';
export const SET_QUESTION_ADD_ANSWER = 'SET_QUESTION_ADD_ANSWER';
export const QUESTION_ADD_ANSWER_BY_TIME = 'QUESTION_ADD_ANSWER';
export const SET_QUESTION_ADD_ANSWER_BY_TIME = 'SET_QUESTION_ADD_ANSWER_BY_TIME';
export const QUESTION_REMOVE_ANSWER = 'QUESTION_REMOVE_ANSWER';
export const SET_QUESTION_REMOVE_ANSWER = 'SET_QUESTION_REMOVE_ANSWER';
export const QUESTION_CREATE = 'QUESTION_CREATE';
export const SET_QUESTION_CREATE = 'SET_QUESTION_CREATE';
export const DELETE_QUESTION = 'DELETE_QUESTION';
export const DELETE_QUESTION_BY_SURVEY = 'DELETE_QUESTION_BY_SURVEY';
export const SET_DELETE_QUESTION = 'SET_DELETE_QUESTION';
export const SET_CURRENT_PRACTICE_STEP = 'SET_CURRENT_PRACTICE_STEP';
export const SET_ADD_CURRENT_PRACTICE_STEP = 'SET_ADD_CURRENT_PRACTICE_STEP';
export const RESET_CURRENT_SURVEY = 'RESET_CURRENT_SURVEY';
export const SET_RESET_CURRENT_SURVEY = 'SET_RESET_CURRENT_SURVEY';
export const SET_RESET_QUESTION_LIST = 'RESET_QUESTION_LIST';
export const SET_RESET_QUESTION_LIST_ACTION = 'SET_RESET_QUESTION_LIST_ACTION';
export const UPDATE_GROUP_QUESTION_ADD_REQUEST = 'UPDATE_GROUP_QUESTION_ADD_REQUEST';
export const UPDATE_GROUP_QUESTION_ADD = 'UPDATE_GROUP_QUESTION_ADD';
export const UPDATE_GROUP_QUESTION_REMOVE_REQUEST = 'UPDATE_GROUP_QUESTION_REMOVE_REQUEST';
export const UPDATE_GROUP_QUESTION_REMOVE = 'UPDATE_GROUP_QUESTION_REMOVE';
export const SET_COPY_SURVEY_REQUEST = 'SET_COPY_SURVEY_REQUEST';
export const SET_COPY_SURVEY = 'SET_COPY_SURVEY';
export const FETCH_PRELOAD_VARIABLE = 'FETCH_PRELOAD_VARIABLE';
export const ADD_PRELOAD_VARIABLE = 'ADD_PRELOAD_VARIABLE';
export const FETCH_SOURCE_VARIABLE = 'FETCH_SOURCE_VARIABLE';
export const FETCH_FIELD_VARIABLE = 'FETCH_FIELD_VARIABLE';
export const UPDATE_PRELOAD_VARIABLE = 'UPDATE_PRELOAD_VARIABLE';
export const DELETE_PRELOAD_VARIABLE = 'DELETE_PRELOAD_VARIABLE';
export const ADD_CALCULATE_VARIABLE = 'ADD_CALCULATE_VARIABLE';
export const FETCH_CALCULATE_VARIABLE = 'FETCH_CALCULATE_VARIABLE';
export const UPDATE_CALCULATE_VARIABLE = 'UPDATE_CALCULATE_VARIABLE';
export const DELETE_CALCULATE_VARIABLE = 'DELETE_CALCULATE_VARIABLE';
export const ADD_PAGE_BREAK = 'ADD_PAGE_BREAK';
export const UPDATE_PAGE_BREAK = 'UPDATE_PAGE_BREAK';
export const DELETE_PAGE_BREAK = 'DELETE_PAGE_BREAK';
export const SET_PAGE_BREAK_LIST = 'PAGE_BREAK_LIST';
export const SET_CALCULATE_VARIABLE_LIST = 'SET_CALCULATE_VARIABLE_LIST';
export const SET_SOURCE_OPTIONS = 'SET_SOURCE_OPTIONS';
export const SET_PRELOAD_VARIABLE = 'SET_PRELOAD_VARIABLE';
export const ADD_PAGE_BREAK_RESOURCES = 'ADD_PAGE_BREAK_RESOURCES';
export const SET_SURVEY_HPA_SCORE_CATEGORIES = 'SET_SURVEY_HPA_SCORE_CATEGORIES';
